/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date: Tue Nov 06 2023 11:57:51
 *
 *******************************************************/

// @flow
import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { withI18n } from '@shopify/react-i18n';
import { Page, Layout, Button, FormLayout, TextStyle } from '@shopify/polaris';
import HowToUse from 'src/components/views/recommendation/general-settings/how-to-use';
import ExceededPlanNotification from 'src/components/containers/common/exceeded-plan-notifications';
import MainMenu from 'src/components/containers/main-menu';
import * as recommendationAction from 'src/stores/actions/recommendation-actions';

import { URL } from 'src/constants/links';

import TitleHelp from 'src/components/views/common/title-help';
import SubSettings from 'src/components/views/recommendation/general-settings/sub-settings';
import { RenderToggleSwitch } from 'src/components/views/common/forms/render-toggle-switch';
import { Field, getFormValues, reduxForm, change } from 'redux-form';
import ExcludeProductList from 'src/components/views/recommendation/general-settings/list/exclude-product-list';
import SelectProductModal from 'src/components/views/recommendation/general-settings/modal/select-product-modal';
import IncludeProductList from 'src/components/views/recommendation/general-settings/list/include-product-list';

const LIMIT_EXCLUDE_PRODUCT = 15;
const LIMIT_INCLUDE_PRODUCT = 5;
class RecommendationGeneralSettings extends Component {
  state = {
    showExcludeProduct: false,
    showIncludeProduct: false
  };

  componentDidMount() {
    const { getGeneralSettings } = this.props;
    getGeneralSettings();
  }

  render() {
    const {
      i18n,
      host,
      handleSubmit,
      formValues = {},
      initialValues = {
        excludeProducts: [],
        includeProducts: []
      },
      recommendationGeneralSettingLoading,
      updateRecommendationGeneralSettingLoading
    } = this.props;

    const { excludeProducts = [], includeProducts = [] } = formValues;
    const isDisablePrimaryAction =
      _.isEqual({
        ...formValues,
        excludeProducts: excludeProducts.map(product => product.id),
        includeProducts: includeProducts.map(product => product.id)
      },
      {
        ...initialValues,
        excludeProducts: initialValues?.excludeProducts?.map(product => product.id),
        includeProducts: initialValues?.includeProducts?.map(product => product.id)
      });
      const isLoading = recommendationGeneralSettingLoading && _.isEmpty(formValues);
    return (
      <div className="BC-Page BC-Page__RecommendationGeneralSettings">
        <MainMenu menuId="menu-recommendation-general-settings" />
        <Page
          title={i18n.translate('AdminHTML.Recommendation.GeneralSettings.title')}
          primaryAction={
            <div className="BC-Page BC-Page__Button">
              <Button
                primary
                disabled={isDisablePrimaryAction}
                loading={updateRecommendationGeneralSettingLoading}
                onClick={handleSubmit(this.handleSave)}>
                {i18n.translate('AdminHTML.Recommendation.GeneralSettings.Common.button_Save')}
              </Button>
            </div>
          }>
          <TitleHelp
            i18n={i18n}
            hrefUserManual={URL['Link_V2_Recommendation_GeneralSettings_ManualGuide']}
            hrefBestPractice={URL['Link_V2_Recommendation_GeneralSettings_BestPractice']}
          />
          <Layout>
            <Layout.Section>
              <div className="BC-Container__Notifications">
                {/* Installation reminder status banner */}
                {/* <InstallationRemindStatusBanner /> */}

                {/* How To Use */}
                <HowToUse host={host} />

                {/* Sticky notification for exceeded plan */}
                <ExceededPlanNotification />
              </div>
            </Layout.Section>
          </Layout>
          <FormLayout>
            <SubSettings
              divider
              isLoading={isLoading}
              title={i18n.translate('AdminHTML.Recommendation.GeneralSettings.CurrentlyView.title')}
              description={i18n.translate(
                'AdminHTML.Recommendation.GeneralSettings.CurrentlyView.description'
              )}>
              <Field
                name="excludeCurrentlyViewedProduct"
                component={RenderToggleSwitch}
                label={i18n.translate(
                  'AdminHTML.Recommendation.GeneralSettings.CurrentlyView.toggleTitle',
                  {
                    t: (
                      <TextStyle variation="strong">
                        {i18n.translate(
                          'AdminHTML.Recommendation.GeneralSettings.CurrentlyView.title'
                        )}
                      </TextStyle>
                    )
                  }
                )}
                helperText={i18n.translate(
                  'AdminHTML.Recommendation.GeneralSettings.CurrentlyView.toggleDescription'
                )}
              />
            </SubSettings>
            {/* <SubSettings
              divider
              isLoading={isLoading}
              title={i18n.translate(
                'AdminHTML.Recommendation.GeneralSettings.PurchaseProduct.title'
              )}
              description={i18n.translate(
                'AdminHTML.Recommendation.GeneralSettings.PurchaseProduct.description'
              )}>
              <Field
                name="excludePurchasedProducts"
                component={RenderToggleSwitch}
                label={i18n.translate(
                  'AdminHTML.Recommendation.GeneralSettings.PurchaseProduct.toggleTitle',
                  {
                    t: (
                      <TextStyle variation="strong">
                        {i18n.translate(
                          'AdminHTML.Recommendation.GeneralSettings.PurchaseProduct.title'
                        )}
                      </TextStyle>
                    )
                  }
                )}
                helperText={i18n.translate(
                  'AdminHTML.Recommendation.GeneralSettings.PurchaseProduct.toggleDescription'
                )}
              />
            </SubSettings> */}
            <SubSettings
              divider
              isLoading={isLoading}
              title={i18n.translate('AdminHTML.Recommendation.GeneralSettings.OutOfStock.title')}
              description={i18n.translate(
                'AdminHTML.Recommendation.GeneralSettings.OutOfStock.description'
              )}>
              <Field
                name="excludeOutOfStockProducts"
                component={RenderToggleSwitch}
                label={i18n.translate(
                  'AdminHTML.Recommendation.GeneralSettings.OutOfStock.toggleTitle',
                  {
                    t: (
                      <TextStyle variation="strong">
                        {i18n.translate(
                          'AdminHTML.Recommendation.GeneralSettings.OutOfStock.title'
                        )}
                      </TextStyle>
                    )
                  }
                )}
              />
            </SubSettings>
            <SubSettings
              divider
              isLoading={isLoading}
              title={i18n.translate(
                'AdminHTML.Recommendation.GeneralSettings.ExcludeProducts.title'
              )}
              description={i18n.translate(
                'AdminHTML.Recommendation.GeneralSettings.ExcludeProducts.description'
              )}>
              <ExcludeProductList
                products={excludeProducts}
                onToggleModal={() => this.toggleModal('showExcludeProduct')}
                onRemove={this.handleRemoveProduct}
                limitSelection={LIMIT_EXCLUDE_PRODUCT}
              />
            </SubSettings>
            <SubSettings
              isLoading={isLoading}
              title={i18n.translate(
                'AdminHTML.Recommendation.GeneralSettings.IncludeProducts.title'
              )}
              description={i18n.translate(
                'AdminHTML.Recommendation.GeneralSettings.IncludeProducts.description'
              )}>
              <IncludeProductList
                products={includeProducts}
                onToggleModal={() => this.toggleModal('showIncludeProduct')}
                onDragEnd={this.handleDragIncludeProduct}
                onRemove={this.handleRemoveProduct}
                limitSelection={LIMIT_INCLUDE_PRODUCT}
              />
            </SubSettings>

            {/*  Exclude Modal*/}
            <SelectProductModal
              active={this.state.showExcludeProduct}
              toggleModal={() => this.toggleModal('showExcludeProduct')}
              title={i18n.translate(
                'AdminHTML.Recommendation.GeneralSettings.ExcludeProducts.modalTitle'
              )}
              description={i18n.translate(
                'AdminHTML.Recommendation.GeneralSettings.ExcludeProducts.modalNote',
                {
                  t1: (
                    <span style={{ color: '#916A00', fontWeight: 600 }}>
                      {i18n.translate(
                        'AdminHTML.Recommendation.GeneralSettings.ExcludeProducts.note_t1'
                      )}
                    </span>
                  ),
                  t2: (
                    <span style={{ color: '#202223', fontWeight: 600 }}>
                      {i18n.translate(
                        'AdminHTML.Recommendation.GeneralSettings.ExcludeProducts.note_t2'
                      )}
                    </span>
                  )
                }
              )}
              fieldName="excludeProducts"
              selectedProducts={excludeProducts}
              formName="RecommendGeneralSettingsForm"
              search={i18n.translate(
                'AdminHTML.Recommendation.GeneralSettings.Common.modalField_Search'
              )}
              limitSelection={LIMIT_EXCLUDE_PRODUCT}
            />
            {/* Include Modal*/}
            <SelectProductModal
              active={this.state.showIncludeProduct}
              toggleModal={() => this.toggleModal('showIncludeProduct')}
              title={i18n.translate(
                'AdminHTML.Recommendation.GeneralSettings.IncludeProducts.modalTitle'
              )}
              description={i18n.translate(
                'AdminHTML.Recommendation.GeneralSettings.IncludeProducts.modalNote',
                {
                  t1: (
                    <span style={{ color: '#916A00', fontWeight: 600 }}>
                      {i18n.translate(
                        'AdminHTML.Recommendation.GeneralSettings.IncludeProducts.note_t1'
                      )}
                    </span>
                  ),
                  t2: (
                    <span style={{ color: '#202223', fontWeight: 600 }}>
                      {i18n.translate(
                        'AdminHTML.Recommendation.GeneralSettings.IncludeProducts.note_t2'
                      )}
                    </span>
                  )
                }
              )}
              fieldName="includeProducts"
              selectedProducts={includeProducts}
              formName="RecommendGeneralSettingsForm"
              search={i18n.translate(
                'AdminHTML.Recommendation.GeneralSettings.Common.modalField_Search'
              )}
              limitSelection={LIMIT_INCLUDE_PRODUCT}
            />
            <div className="footer">
              <div className="BC-Page BC-Page__Button">
                <Button
                  loading={updateRecommendationGeneralSettingLoading}
                  primary
                  disabled={isDisablePrimaryAction}
                  onClick={handleSubmit(this.handleSave)}>
                  {i18n.translate('AdminHTML.Recommendation.GeneralSettings.Common.button_Save')}
                </Button>
              </div>
            </div>
          </FormLayout>
        </Page>
      </div>
    );
  }

  /**
   * handle toggle include/exclude products modal
   * @param {string} name
   */
  toggleModal = name => {
    this.setState({ [name]: !this.state[name] });
  };

  /**
   * handle save general settings
   * @param {FormValue} data
   */
  handleSave = async data => {
    const { updateGeneralSettings } = this.props;
    updateGeneralSettings(data);
  };

  // Remove source product from redux-form field
  handleRemoveProduct = (name, product) => {
    const { updateRecommendGeneralSettingsForm, formValues } = this.props;
    const { [name]: productList } = formValues;
    const newProductList = _.filter(productList, item => item.id !== product.id);
    updateRecommendGeneralSettingsForm(name, newProductList);
    if (_.isEmpty(newProductList)) {
      updateRecommendGeneralSettingsForm(name, []);
    }
  };

  // Update recommended products after reordering
  handleDragIncludeProduct = products => {
    const { updateRecommendGeneralSettingsForm } = this.props;
    updateRecommendGeneralSettingsForm('includeProducts', products);
  };
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  getGeneralSettings: () => dispatch(recommendationAction.getGeneralSettings()),
  updateRecommendGeneralSettingsForm: (field, value) =>
    dispatch(change(`RecommendGeneralSettingsForm`, field, value)),
  updateGeneralSettings: generalSettings =>
    dispatch(recommendationAction.updateGeneralSettings(generalSettings))
});

const mapStateToProps = (state, props) => {
  // Get access scopes
  const host = _.get(state.oauth, 'host', '');
  const settings = _.get(state.oauth, 'tenantApp.settings', {});
  const recommendationGeneralSettings = _.get(
    state.recommendation,
    'recommendationGeneralSettings',
    {}
  );
  const recommendationGeneralSettingLoading = _.get(
    state.recommendation,
    'recommendationGeneralSettingLoading',
    false
  );
  const updateRecommendationGeneralSettingLoading = _.get(
    state.recommendation,
    'updateRecommendationGeneralSettingLoading',
    false
  );
  const formValues = getFormValues('RecommendGeneralSettingsForm')(state);

  return {
    host,
    settings,
    formValues,
    initialValues: recommendationGeneralSettings,
    recommendationGeneralSettingLoading,
    updateRecommendationGeneralSettingLoading
  };
};

const RecommendGeneralSettingsForm = reduxForm({
  form: 'RecommendGeneralSettingsForm', // a unique identifier for this form
  enableReinitialize: true
})(RecommendationGeneralSettings);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(RecommendGeneralSettingsForm));
